var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47187 14.1384L6.08604 17.7525C7.34437 19.0109 9.36854 19.0592 10.6852 17.8617L16.136 12.9059C17.0052 12.1167 17.5002 10.9975 17.5002 9.82337V5.83337C17.5002 4.45254 16.381 3.33337 15.0002 3.33337H10.7777C9.74104 3.33337 8.74187 3.72004 7.97521 4.41671L2.58687 9.31504C1.17854 10.595 1.12604 12.7925 2.47187 14.1384Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 8.33333C15.0871 8.33333 15.8333 7.58714 15.8333 6.66667C15.8333 5.74619 15.0871 5 14.1667 5C13.2462 5 12.5 5.74619 12.5 6.66667C12.5 7.58714 13.2462 8.33333 14.1667 8.33333Z",
    fill: "#474B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTag);
export default __webpack_public_path__ + "static/media/ic-tag.bd2a460e82dcc4a968e17a0969fec938.svg";
export { ForwardRef as ReactComponent };